import type { PropsWithChildren } from 'react';

type NotificationListProps = {
    listLabel?: string;
};

export const NotificationList = (props: PropsWithChildren<NotificationListProps>) => (
    <div className='notification' data-testid='notifications-div'>
        {/** biome-ignore lint/a11y/useAriaPropsSupportedByRole: might be used for testing */}
        <div
            className='children-last-border-bottom-none'
            aria-label={props.listLabel ? props.listLabel : 'notifications-list'}
            data-testid='notifications-list'
        >
            {props.children}
        </div>
    </div>
);
